import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import { saveAs } from 'file-saver';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import { prepareFormObjectForSave } from '@/core/tools/forms/prepare_form_object_for_save';

interface ShiftVDPFactState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    clientId: any;

    // productList: any[];
    // productVariantList: any[];
    prefereds: any;
    relatedFactsList: any[];
    meta: any;

    targetForDelete: any[];
    // inWorkStatus: any;
    // formationStatus: any;
    // products: any[];
    remains: any[];
}

const state: ShiftVDPFactState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    clientId: null,
    meta: null,

    // productList: [],
    // productVariantList: [],
    prefereds: [],
    relatedFactsList: [],

    targetForDelete: [],
    // products: [],
    remains: []
};

const initState: any = cloneDeep(state);

const GET_SHIFT_FACT_VDP = 'GET_SHIFT_FACT_VDP';
const GET_SCMEMA_SHIFT_FACT_VDP = 'GET_SCMEMA_SHIFT_FACT_VDP';
const SHIFT_PLAN = 'SHIFT_PLAN';
const SHIFT_PLAN_CNT = 'SHIFT_PLAN_CNT';
const SHIFT_FACT = 'SHIFT_FACT';
const SHIFT_FACT_STORAGES = 'SHIFT_FACT_STORAGES';
const SHIFT_JOURNAL= 'SHIFT_JOURNAL';


export const actions: ActionTree<ShiftVDPFactState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId, clientId, remains }) {
        const vm = (this as any)._vm;

        state.documentId = documentId;
        state.clientId = clientId;
        state.remains = remains;

        return new Promise((resolve, reject) => {
          commit('START_LOADING');
          vm.$db([
            vm.$q(GET_SHIFT_FACT_VDP)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'sfv.id',
                  plan_id: 'spv.id',
                  number: 'spv.number',
                  shift_plan_id: 'sfv.shift_plan_id',
                  base_name: {$concat: ['base.name', {$: ' '}, 'vst.name']},
                  base_id: 'base.id',
                  quantity: 'sfv.quantity',
                  container_name: 'container.name',
                  weight_brutto: 'sfv.weight_brutto',
                  weight_palett: 'sfv.weight_palett',
                  weight_neto: 'sfv.weight_neto',
                  plan_weight: 'sfv.plan_weight',
                  deviant_weight: 'sfv.deviant_weight',
                  extract_time: 'sfv.extract_time',
                  ripening_place: 'sfv.ripening_place',
                  comment: 'sfv.comment',
                  mark_no_incident: 'vbm.no_incident',
                  mark_water_state: 'vbm.water_state',
                  mark_no_fat: 'vbm.no_fat',
                  mark_normal_acidity: 'vbm.normal_acidity',
                  label_text: 'sfv.label_text',
                  volume_type: 'vv.type',
                  presript_total_weight: 'p.total_weight',
                  base_params: {
                    $obj: {
                        upper_ok: 'base.upper_ok',
                        upper_middle: 'base.upper_middle',
                        upper_warn: 'base.upper_warn',
                        lower_ok: 'base.lower_ok',
                        lower_middle: 'base.lower_middle',
                        lower_warn: 'base.lower_warn',
                        upper_getting_warn_dr: 'base.upper_getting_warn_dr',
                        upper_getting_middle_dr: 'base.upper_getting_middle_dr',
                        upper_getting_ok: 'base.upper_getting_ok',
                        upper_getting_middle_k: 'base.upper_getting_middle_k',
                        upper_getting_warn_k: 'base.upper_getting_warn_k',
                        lower_getting_warn_dr: 'base.lower_getting_warn_dr',
                        lower_getting_middle_dr: 'base.lower_getting_middle_dr',
                        lower_getting_ok: 'base.lower_getting_ok',
                        lower_getting_middle_k: 'base.lower_getting_middle_k',
                        lower_getting_warn_k: 'base.lower_getting_warn_k',
                        water_border_ok: 'base.water_border_ok',
                        water_border_ko: 'base.water_border_ko',
                    }
                  },
                  storages: {
                    $array_agg: {
                        $obj: {
                            id: 'sfvs.id',
                            name: 'storage.name',
                            quantity: 'sfvs.quantity',
                        }
                    }
                }
                },
                from: 's:shift_plan_vdp',
                from_as: 'spv',
                joins: [
                  {
                    join: 's:shift_fact_vdp',
                    type: 'left',
                    as:   'sfv',
                    on: {
                      $eq: ['sfv.shift_plan_id', 'spv.id']
                    }
                  },
                  {
                    join: 's:voc_bases',
                    type: 'left',
                    as:   'base',
                    on: {
                      $eq: ['spv.base_id', 'base.id']
                    }
                  },
                  {
                    join: 's:prescripts',
                    type: 'left',
                    as:   'p',
                    on: {
                      $and: [
                        {$eq: ['base.id', 'p.base_id']},
                        {$null: ['p.archived_at']}
                      ]
                    }
                  },
                  {
                    join: 's:voc_starter_types',
                    type: 'left',
                    as:   'vst',
                    on: {
                      $eq: ['vst.id', 'spv.starter_type_id']
                    }
                  },
                  {
                    join: 's:voc_containers',
                    type: 'left',
                    as:   'container',
                    on: {
                      $eq: ['sfv.container_id', 'container.id']
                    }
                  },
                  {
                    join: 's:view_base_mark',
                    type: 'left',
                    as:   'vbm',
                    on: {
                      $eq: ['vbm.id', 'sfv.id']
                    }
                  },
                  {
                    join: 's:shift_fact_vdp_storages',
                    type: 'left',
                    as:   'sfvs',
                    on: {
                      $eq: ['sfvs.fact_id', 'sfv.id']
                    }
                  },
                  {
                    join: 's:voc_storages',
                    type: 'left',
                    as:   'storage',
                    on: {
                      $eq: ['sfvs.storage_id', 'storage.id']
                    }
                  },
                  {
                    join: 's:voc_lines',
                    type: 'left',
                    as:   'vl',
                    on: { 
                      $eq: ['vl.id', 'spv.line_id']
                    }
                  },
                  {
                    join: 's:voc_volumes',
                    type: 'left',
                    as:   'vv',
                    on: {
                      $eq: ['vv.id', 'vl.volume_id']
                    }
                  },

                ],
                order: [
                  {$asc: ['spv.id']}
                ],
                where: {
                  $and: [
                    {$eq: [`spv.shift_id`, {$: documentId}]},
                    {$null: [`spv.deleted_at`]}
                  ]
                },
                groups: [
                  'sfv.id',
                  'spv.id',
                  'spv.number',
                  'vst.name',
                  'sfv.shift_plan_id',
                  {$concat: ['base.name', {$: ' '}, 'vst.name']},
                  'base.id',
                  'sfv.quantity',
                  'container.name',
                  'sfv.weight_brutto',
                  'sfv.weight_palett',
                  'sfv.weight_neto',
                  'sfv.plan_weight',
                  'sfv.deviant_weight',
                  'sfv.extract_time',
                  'sfv.comment',
                  'vbm.no_incident',
                  'vbm.water_state',
                  'vbm.no_fat',
                  'vbm.normal_acidity',
                  'vv.type',
                  'p.total_weight'
                ]
              }),
              vm.$q(GET_SCMEMA_SHIFT_FACT_VDP)
              .raw('schemas.get')
              .action({
                  id: `s:shift_fact_vdp`
              }),
          ]).then((result: ServerResult) => {
            const opRelResult = result.getOperation(GET_SHIFT_FACT_VDP);
            if (!opRelResult.hasError()) {
              state.relatedFactsList = opRelResult.getContent().documents.map((item: any) => {
                item.marks_count = 0;
                item.marks_count += item.mark_no_incident !== null ? 1 : 0;
                item.marks_count += item.mark_water_state !== null ? 1 : 0;
                item.marks_count += item.mark_no_fat !== null ? 1 : 0;
                item.marks_count += item.mark_normal_acidity !== null ? 1 : 0;
                return item
              })
            }
            const opRelSchema = result.getOperation(GET_SCMEMA_SHIFT_FACT_VDP);
            if (!opRelSchema.hasError()) {
              state.meta = fetchEnumsFromSchema(opRelSchema.getContent().schema)
            }
            commit('LOADED_SUCCESS');

            resolve(null);
          });
        })
    },

    exportAsXLSX({rootState, state}, {documentId}) {
      const vm = (this as any)._vm;

      return new Promise((resolve, reject) => {
          vm.$db([
              vm.$q('EXPORT')
              .raw('documents.report')
              .action({
                template: `
<!DOCTYPE html>
<table font=Verdana font-size=10 orientation="portrait" area="A:K" scale="45">
<tr height=30>
  <td wrap border bold bgcolor=FF72BF44 width=30>Номер партии</td>
  <td wrap border bold bgcolor=FF72BF44 width=30>Наименование базы</td>
  <td wrap border bold bgcolor=FF72BF44 width=25>Ведер с 1 партии, шт</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Емкость тары</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Выход с 1 партии, брутто</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Вес паллеты, кг</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Выход с 1 партии, нетто, кг</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Плановое значение, кг</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Отклонение, кг</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Место хранения</td>
</tr>
{{#facts.documents}}
  <tr height="auto">
    <td wrap border base >{{number}}</td>
    <td wrap border base >{{base_name}}</td>
    <td wrap border base type=number round align=center>{{quantity}}</td>
    <td wrap border base align=center>{{container_name}}</td>
    <td wrap border base type=number round align=center>{{weight_brutto}}</td>
    <td wrap border base type=number round align=center>{{weight_palett}}</td>
    <td wrap border base type=number round align=center>{{weight_neto}}</td>
    <td wrap border base type=number round align=center>{{plan_weight}}</td>
    <td wrap border base type=number round align=center>{{deviant_weight}}</td>
    <td wrap border base align=center>{{storage_name}}</td>
  </tr>
{{/facts.documents}}
</table>
                `,
                queries: {
                  facts: {
                    columns: {
                      id: 'sfv.id',
                      plan_id: 'spv.id',
                      number: 'spv.number',
                      shift_plan_id: 'sfv.shift_plan_id',
                      storage_name: 'storage.name',
                      storage_id: 'storage.id',
                      base_name: {$concat: ['base.name', {$: ' '}, 'vst.name']},
                      base_id: 'base.id',
                      quantity: 'sfv.quantity',
                      container_name: 'container.name',
                      weight_brutto: 'sfv.weight_brutto',
                      weight_palett: 'sfv.weight_palett',
                      weight_neto: 'sfv.weight_neto',
                      plan_weight: 'sfv.plan_weight',
                      deviant_weight: 'sfv.deviant_weight',
                      comment: 'sfv.comment',
                    },
                    from: 's:shift_fact_vdp',
                    from_as: 'sfv',
                    joins: [
                      {
                        join: 's:shift_plan_vdp',
                        type: 'left',
                        as:   'spv',
                        on: {
                          $eq: ['sfv.shift_plan_id', 'spv.id']
                        }
                      },
                      {
                        join: 's:voc_storages',
                        type: 'left',
                        as:   'storage',
                        on: {
                          $eq: ['sfv.storage_id', 'storage.id']
                        }
                      },
                      {
                        join: 's:voc_bases',
                        type: 'left',
                        as:   'base',
                        on: {
                          $eq: ['spv.base_id', 'base.id']
                        }
                      },
                      {
                        join: 's:voc_starter_types',
                        type: 'left',
                        as:   'vst',
                        on: {
                          $eq: ['vst.id', 'spv.starter_type_id']
                        }
                      },
                      {
                        join: 's:voc_containers',
                        type: 'left',
                        as:   'container',
                        on: {
                          $eq: ['sfv.container_id', 'container.id']
                        }
                      },
                    ],
                    order: [
                      {$asc: ['sfv.id']}
                    ],
                    where: {
                      $eq: [`spv.shift_id`, {$: documentId}]
                    }
                  },
                },
                format: 'xlsx'
              })
          ]).then(((result: ServerResult) => {
              const exportOpContent = result.getOperation('EXPORT').getContent();
              const fToken = exportOpContent.token;
              const aToken = (rootState as any).ubic.token
              const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
              saveAs(fileUrl, 'export.xlsx')

              resolve(null);
          }));
      })
    },
    copyPlan({state, commit}, {planId, shiftId, number, value}) {

      console.log(planId, shiftId, number);
      const vm = (this as any)._vm;

      return new Promise((resolve, reject) => {
          commit('START_LOADING');

          vm.$db([
              vm.$q(SHIFT_PLAN)
                  .raw('documents.get')
                  .action({
                      id: planId
                  }),
              vm.$q(SHIFT_PLAN_CNT)
                  .raw('documents.list')
                  .action({
                      columns: {
                        cnt: { $count: 'plan.id'}
                      },
                      from: 's:shift_plan_vdp',
                      from_as: 'plan',
                      where: {
                        $and: [
                          {$eq: [`plan.shift_id`, {$: shiftId}]},
                          {$ilike: [`plan.number`, {$: `${number}.%`}]}
                        ]
                      }
                  }),
              vm.$q(SHIFT_FACT)
                  .raw('schemas.get')
                  .action({
                      id: `s:shift_fact_vdp`
                  }),
              vm.$q(SHIFT_FACT_STORAGES)
                  .raw('schemas.get')
                  .action({
                      id: `s:shift_fact_vdp_storages`
                  }),
              vm.$q(SHIFT_JOURNAL)
                  .raw('schemas.get')
                  .action({
                      id: `s:shift_journal_vdp`
                  }),
          ]).then((result: ServerResult) => {
            const plan = result.getOperation(SHIFT_PLAN).getContent().document;
            const plan_cnt = result.getOperation(SHIFT_PLAN_CNT).getContent().documents[0].cnt;
            const fact_schema = result.getOperation(SHIFT_FACT).getContent().schema
            const fact_storages_schema = result.getOperation(SHIFT_FACT_STORAGES).getContent().schema
            const journal_schema = result.getOperation(SHIFT_JOURNAL).getContent().schema
            const fact_fields = fact_schema.fields.reduce((prev: any, item: any) => {
              if (!['created_at', 'updated_at'].includes(item.code)) {
                prev[item.code] = 'fact.' + item.code;
              }
              return prev
            }, {});
            const fact_storages_fields = fact_storages_schema.fields.reduce((prev: any, item: any) => {
              if (!['id', 'created_at', 'updated_at'].includes(item.code)) {
                prev[item.code] = 'storage.' + item.code;
              }
              return prev
            }, {});
            const journal_fields = journal_schema.fields.reduce((prev: any, item: any) => {
              if (!['id', 'created_at', 'updated_at'].includes(item.code)) {
                prev[item.code] = 'journal.' + item.code;
              }
              return prev
            }, {});

            vm.$db([
              vm.$q(SHIFT_FACT)
                  .raw('documents.list')
                  .action({
                      columns: fact_fields,
                      from: 's:shift_fact_vdp',
                      from_as: 'fact',
                      where: {
                        $eq: [`fact.shift_plan_id`, {$: planId}]
                      }
                  }),
              vm.$q(SHIFT_FACT_STORAGES)
                  .raw('documents.list')
                  .action({
                      columns: fact_storages_fields,
                      from: 's:shift_fact_vdp_storages',
                      from_as: 'storage',
                      joins: [
                        {
                          join: 's:shift_fact_vdp',
                          type: 'left',
                          as:   'fact',
                          on: {
                            $eq: ['fact.id', 'storage.fact_id']
                          }
                        },
                      ],
                      where: {
                        $eq: [`fact.shift_plan_id`, {$: planId}]
                      }
                  }),
              vm.$q(SHIFT_JOURNAL)
                  .raw('documents.list')
                  .action({
                      columns: journal_fields,
                      from: 's:shift_journal_vdp',
                      from_as: 'journal',
                      joins: [
                        {
                          join: 's:shift_fact_vdp',
                          type: 'left',
                          as:   'fact',
                          on: {
                            $eq: ['fact.id', 'journal.fact_id']
                          }
                        },
                      ],
                      where: {
                        $eq: [`fact.shift_plan_id`, {$: planId}]
                      }
                  }),
            ]).then((result: ServerResult) => {
              delete plan.id
              delete plan.created_at
              delete plan.updated_at
              const fact = result.getOperation(SHIFT_FACT).getContent().documents[0];
              const fact_storages = result.getOperation(SHIFT_FACT_STORAGES).getContent().documents;
              const journal = result.getOperation(SHIFT_JOURNAL).getContent().documents[0];
              const _mult_a = value / fact.quantity;
              const _mult_b = 1 - value / fact.quantity;
              vm.$db([
                vm.$q('SHIFT_FACT_DATA_SAVE')
                .update(fact.id, prepareFormObjectForSave(fact_schema, {
                  quantity: (fact.quantity * _mult_b) * 1.0,
                  weight_brutto: (fact.weight_brutto * _mult_b) * 1.0,
                  weight_palett: fact.weight_palett,
                  weight_neto: (fact.weight_neto * _mult_b) * 1.0,
                  plan_weight: (fact.plan_weight * _mult_b) * 1.0,
                  deviant_weight: (fact.plan_weight * _mult_b - (fact.weight_neto * _mult_b)) * 1.0,
                })),
                vm.$q('SHIFT_PLAN_DATA_SAVE')
                .create('s:shift_plan_vdp', {
                  ...plan,
                  number: `${plan.number}.${plan_cnt + 1}`,
                })
                .withManyRelation('shift_fact_vdp', 'shift_plan_id', (createRelated: any) => {
                    delete fact.id
                    return [createRelated(prepareFormObjectForSave(fact_schema, {
                      ...fact,
                      quantity: value,
                      weight_brutto: fact.weight_brutto * _mult_a * 1.0,
                      weight_neto: (fact.weight_neto * _mult_a) * 1.0,
                      weight_palett: 0,
                      plan_weight: fact.plan_weight * _mult_a * 1.0,
                      deviant_weight: (fact.plan_weight * _mult_a - (fact.weight_neto * _mult_a))* 1.0,
                    }))
                  ]
                })
              ]).then((result: ServerResult) => {
                const fact_id = result.getOperation('SHIFT_PLAN_DATA_SAVE').getContent().create_related['s:shift_fact_vdp/shift_plan_id'].documents[0].id
            vm.$db([
                  vm.$q('SHIFT_FACT_DATA_SAVE')
                  .update(fact_id, {})
                  .createManyRelation('shift_journal_vdp', 'fact_id', (createRelated: any) => {
                    return journal ?[createRelated({
                      ...journal,
                      quantity: value,
                    })] : []
                  })
                  .createManyRelation('shift_fact_vdp_storages', 'fact_id', (createRelated: any) => {
                    return fact_storages.map((item: any) => {
                      return createRelated(item)
                    })
                  })
                ]).then((result: ServerResult) => {
                  commit('LOADED_SUCCESS');
                  resolve(null);
                })
                .catch((error: any) => {
                    console.log('error', error)
                    commit('LOADED_ERROR');
                    reject()
                })
              })
              .catch((error: any) => {
                  console.log('error', error)
                  commit('LOADED_ERROR');
                  reject()
              })

            })
            .catch((error: any) => {
                console.log('error', error)
                commit('LOADED_ERROR');
                reject()
            })
          })
          .catch((error: any) => {
              console.log('error', error)
              commit('LOADED_ERROR');
              reject()
          })
      })

    },
};

export const mutations: MutationTree<ShiftVDPFactState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  // SET_DEAL_DATA(state, data) {
  //     const schema = data.schema;
  //     const document = data.documents[0];

  //     state.document = document
  // },

  // SET_DEAL_PRODRUCTS(state, data) {
  //     state.products = data.documents;
  // },

  // SET_STATUSES_INFO(state, {inWorkStatus, formationStatus}) {
  //     state.inWorkStatus = inWorkStatus;
  //     state.formationStatus = formationStatus;
  // },
};

export const getters: GetterTree<ShiftVDPFactState, RootState> = {
  totals : (state: ShiftVDPFactState) => {
    return state.relatedFactsList.reduce((val: any, item: any) => {
        const keys = ['weight_brutto', 'weight_neto', 'deviant_weight', 'weight_palett', 'plan_weight']
        keys.map((key: string) => {
          if (!val[key]) {
            val[key] = 0
          }
          val[key] += item[key] ? parseFloat(item[key]) : 0
        })
        return val
      }, {})
    },
    rotateFacts: (state: ShiftVDPFactState) => {
      return state.relatedFactsList.reduce((prev: any, item: any) => {
        Object.keys(item).map((key: any) => {
          if (!prev[key]){
            prev[key] = [];
          }
          prev[key].push(item[key]);
        })
        prev.rows.push(item)
        return prev
      }, {rows: []})  
    }
};

export const STORE_KEY = '$_shift_vdp_fact_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
